<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        :class="twClass"
    >
        <path
            d="M448 32C465.7 32 480 46.3 480 64L480 114C480 165.3 447.5 210.4 400 227.1L400 576C400 593.7 385.7 608 368 608C350.3 608 336 593.7 336 576L336 416.4C336 416.3 336 416.2 336 416C336 407.2 328.8 400 320 400C311.2 400 304 407.2 304 416L304 416L304 576C304 593.7 289.7 608 272 608C254.3 608 240 593.7 240 576L240 292.4C239.7 292.9 239.4 293.4 239 293.9L187.1 377C177.7 392 158 396.5 143 387.2C128 377.9 123.5 358 132.9 343L184.8 260C207.3 224 243.2 198.4 284.5 188.9L372.6 168.6C398 162.7 416 140.1 416 114L416 64C416 46.3 430.3 32 448 32zM264 88C264 57.1 289.1 32 320 32C350.9 32 376 57.1 376 88C376 118.9 350.9 144 320 144C289.1 144 264 118.9 264 88z"
        />
    </svg>
</template>

<script setup lang="ts">
const {twClass = 'w-8 h-8 fill-neutral-850'} = defineProps<{ twClass?: string }>();
</script>
